import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { CircularProgress } from '../Progress/CircularProgress';

import Surface from '../Surface/Surface';
import ModalHeader from './ModalHeader';
import { ModalFooterUI } from './ModalFooter';
import { ReactNode } from 'react';
import { MobileSubmenuSlider } from '@cube3/cubicle/src/components/Surface/MobileSubmenuSlider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    surface: {
      display: 'flex',
      flexDirection: 'column',
      width: 'calc(100vw - 55px)',
      height: '100%'
    },
    contents: {
      margin: '8px 16px 0px 0px',
      // 64px both on bottom and on top - 40 headerHeight - 64 footerHeight - 64 some space for margin and scrollbar
      minHeight: 'calc(100vh - 600px)', // 4px margin both on bottom surface, and on top - 56 headerHeight - 64 footerHeight - extra mobile px
      '& > :last-child': {
        marginBottom: 8
      }
    },
    loadingOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      width: 'auto',
      background: theme.customPalette.backgroundAccent.blackAccent3,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  })
);

interface ModalMbileSurfaceUIProps {
  loading?: boolean;
  showCloseButton?: boolean;
  onCloseEvent?: Function;
  children?: ReactNode;
  /** Component in footer left, centered */
  footerLeftComponent?: JSX.Element;
  /** Component in footer right, centered */
  footerRightComponent?: JSX.Element;
  extraSurfaceProperties?: any;
  title?: string | JSX.Element;
}

function ModalMbileSurfaceUI(props: ModalMbileSurfaceUIProps) {
  const {
    extraSurfaceProperties,
    footerLeftComponent,
    footerRightComponent,
    loading,
    onCloseEvent,
    showCloseButton,
    title
  } = props;
  const classes = useStyles({});
  const { surface, loadingOverlay, contents } = classes;
  return (
    <MobileSubmenuSlider onClose={() => onCloseEvent?.()}>
      <Surface className={surface} background={'transparent'}>
        {title && (
          <ModalHeader
            onClickClose={onCloseEvent ? () => onCloseEvent() : undefined}
            showCloseButton={showCloseButton}
            title={title}
          />
        )}

        <div className={contents}>{props.children}</div>

        {(footerLeftComponent || footerRightComponent) && (
          <ModalFooterUI
            footerLeftComponent={footerLeftComponent}
            footerRightComponent={footerRightComponent}
          />
        )}

        {/* Show circular progress, blocking interaction when in loading state */}
        {loading && (
          <div className={loadingOverlay}>
            <CircularProgress />
          </div>
        )}
      </Surface>
    </MobileSubmenuSlider>
  );
}

export default ModalMbileSurfaceUI;
